import { render, staticRenderFns } from "./NewButton.vue?vue&type=template&id=4a0cd4bc&scoped=true&"
import script from "./NewButton.vue?vue&type=script&lang=ts&"
export * from "./NewButton.vue?vue&type=script&lang=ts&"
import style0 from "./NewButton.vue?vue&type=style&index=0&id=4a0cd4bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0cd4bc",
  null
  
)

export default component.exports